import { motion } from "framer-motion";

// Scroll-triggered fade + slide reveal.
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for large display headings.
export const MaskedLines = ({ lines, className = "", lineClassName = "", startDelay = 0.15 }) => (
  <span className={className} aria-label={lines.join(" ")}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden" aria-hidden="true">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{
            duration: 0.9,
            delay: startDelay + i * 0.12,
            ease: [0.76, 0, 0.24, 1],
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
